import * as common from '../apiCommon';
import * as DocType from '../../constants/constant_doc_types';



export function deleteJob(app, params) {
  const { id } = params;
  return common.deleteDoc(app, {
    id: id,
    docType: DocType.JOB
  });
}




export function fetchJobById(app, params) {
  const { id } = params;
  const docType = 'job';
  return common.getDoc(app, { id, docType });
}
